import React from 'react'
import { AxiosProvider, Request, Get } from 'react-axios'
import { Toaster, Position } from '@blueprintjs/core'

var axios = require('axios')
/*const API_BASE_URL = 'https://en605401.jamalmahboob.com:5000'
const dev_API_BASE_URL = 'http://10.0.0.29:5000'*/

export const MOVE_UP_ACTION = "MOVE_UP_ACTION"
export const MOVE_DOWN_ACTION = "MOVE_DOWN_ACTION"
export const MOVE_LEFT_ACTION = "MOVE_LEFT_ACTION"
export const MOVE_RIGHT_ACTION = "MOVE_RIGHT_ACTION"
export const MOVE_SECRET_ACTION = "MOVE_SECRET_ACTION"
export const SELECT_PLAYER_ACTION = "SELECT_PLAYER_ACTION"
export const SET_GAME_STATE = "SET_GAME_STATE"
export const START_GAME_ACTION = "START_GAME_ACTION"
export const SUGGEST_ACTION = "SUGGEST_ACTION"
export const ACCUSE_ACTION = "ACCUSE_ACTION"

const ActionToaster = Toaster.create({
    className: 'playerTokenToaster',
    position: Position.BOTTOM_RIGHT
})

export function suggestAction(weapon, room, character, player) {
    return (dispatch) => {
        axios.get(process.env.REACT_APP_API + window.location.pathname.replace('game', 'api/game') + '/suggest?w=' + weapon + '&r=' + room + '&tp=' + character + '&cp=' +  player )
            .then( (response) => {
                console.debug(response.data)
                let parsed = JSON.stringify(response.data)
                ActionToaster.show({
                    message: parsed
                })
            })
            .catch( (error) => {
                console.debug(error)
            })
    }
}

export function accuseAction(weapon, room, character, player) {
    return (dispatch) => {
        axios.get(process.env.REACT_APP_API + window.location.pathname.replace('game', 'api/game') + '/accuse?w=' + weapon + '&r=' + room + '&tp=' + character + '&cp=' + player)
            .then( (response) => {
                console.debug(response)
            })
            .catch( (error) => {
                console.debug(error)
            })
    }
}

export function startGameAction() {
    return (dispatch) => {
        axios.get(process.env.REACT_APP_API + window.location.pathname.replace('game','api/game') + '/start')
            .then( (response) => {
                console.debug(response)
            })
            .catch( (error) => {
                console.debug(error)
            })
    }
}

export function moveUpAction(player) {
    return (dispatch) => {
        axios.get(process.env.REACT_APP_API + window.location.pathname.replace('game','api/game') + '/movePlayer?p=' + player + '&d=up')
            .then( (response) => {
                console.debug(response)
                if(response.data.search('occupied') > 0) {
                    ActionToaster.show({
                        message: "Invalid move selection.  Only one player is allowed to occupy a hallway at a time."
                    })
                }
            })
            .catch( (error) => {
                console.debug(error)
            })
    }
}

export function moveDownAction(player) {
    return (dispatch) => {
        axios.get(process.env.REACT_APP_API + window.location.pathname.replace('game','api/game') + '/movePlayer?p=' + player + '&d=down')
            .then( (response) => {
                console.debug(response)
                if(response.data.search('occupied') > 0) {
                    ActionToaster.show({
                        message: "Invalid move selection.  Only one player is allowed to occupy a hallway at a time."
                    })
                }
                /*dispatch({
                    type: MOVE_UP_ACTION, player
                })*/
            })
            .catch( (error) => {
                console.debug(error)
            })
    }
}

export function moveLeftAction(player) {
    return (dispatch) => {
        axios.get(process.env.REACT_APP_API + window.location.pathname.replace('game','api/game') + '/movePlayer?p=' + player + '&d=left')
            .then( (response) => {
                console.debug(response)
                if(response.data.search('occupied') > 0) {
                    ActionToaster.show({
                        message: "Invalid move selection.  Only one player is allowed to occupy a hallway at a time."
                    })
                }
                /*dispatch({
                    type: MOVE_UP_ACTION, player
                })*/
            })
            .catch( (error) => {
                console.debug(error)
            })
    }
}

export function moveRightAction(player) {
    return (dispatch) => {
        axios.get(process.env.REACT_APP_API + window.location.pathname.replace('game','api/game') + '/movePlayer?p=' + player + '&d=right')
            .then( (response) => {
                console.debug(response)
                if(response.data.search('occupied') > 0) {
                    ActionToaster.show({
                        message: "Invalid move selection.  Only one player is allowed to occupy a hallway at a time."
                    })
                }
                /*dispatch({
                    type: MOVE_UP_ACTION, player
                })*/
            })
            .catch( (error) => {
                console.debug(error)
            })
    }
}

export function moveSecretAction(player) {
    return (dispatch) => {
        axios.get(process.env.REACT_APP_API + window.location.pathname.replace('game','api/game') + '/movePlayer?p=' + player + '&d=secret')
            .then( (response) => {
                console.debug(response)
            })
            .catch( (error) => {
                console.debug(error)
            })
    }
}

export function selectPlayerAction(player) {
    return (dispatch) => {
        axios.get(process.env.REACT_APP_API + window.location.pathname.replace('game','api/game') + '/movePlayer?p=' + player + '&d=secret')
            .then( (response) => {
                console.debug(response)
                /*dispatch({
                    type: MOVE_UP_ACTION, player
                })*/
            })
            .catch( (error) => {
                console.debug(error)
            })
    }
}

export function endTurnAction(player) {
    return (dispatch) => {
        axios.get(process.env.REACT_APP_API + window.location.pathname.replace('game','api/game') + '/endturn')
            .then( (response) => {
                console.debug(response)
            })
            .catch( (error) => {
                console.debug(error)
            })
    }
}

export function setGameState(game) {
    return {
        type: SET_GAME_STATE,
        payload: game
    }
}

export function getGameList() {
    <Get url="/api/gamelist">
        {(response) => {
            if (response) {
                console.debug(response)
                return(response)
            }
        }}
    </Get>
}



// WEBPACK FOOTER //
// ./src/actions/playerActions.jsx